export const ViewAsStorageKey = 'view-as'
